// packages/ui/src/surface/composedTree.ts
//
// The page as the browser draws it, across shadow roots: a widget sealed in a shadow root (WidgetSurface.ts) is still
// laid out inside the page's elements, and focus inside it shows on the document only as its host.

/** The focused element, inside shadow roots too (as MUI's `getActiveElement`): the document reports only their host. */
export function deepActiveElement(doc: Document): Element | null {
	let element = doc.activeElement;
	while (element?.shadowRoot?.activeElement) element = element.shadowRoot.activeElement;
	return element;
}

/**
 * Whether `node` is a shadow root: a document fragment (node type 11) with a host. Not `instanceof ShadowRoot`, which
 * needs the node's own window's class (and a DOM without shadow roots has none).
 */
export function isShadowRoot(node: Node | null | undefined): node is ShadowRoot {
	return node != null && node.nodeType === 11 && 'host' in node;
}

/** An element's parent as laid out: across the edge of a shadow root, its host. */
export function composedParentElement(element: Element): Element | null {
	if (element.parentElement !== null) return element.parentElement;
	const parent = element.parentNode;
	return isShadowRoot(parent) ? parent.host : null;
}
